//
//

import PISideBarFilters from "./PISideBarFilters.vue";
import PIDataTable from "./PIDataTable.vue";

export default {
    components: {
        PISideBarFilters,
        PIDataTable
    },

    data() {
        return {
            mode: "a",
            searchingAction: false,
            payloadToSend: {},
            objectToSend: {},
            searchData: ""
        };
    },
    methods: {
        applyFilterPayload(payloadToSend) {
            const { size } = this.payloadToSend;
            this.payloadToSend = payloadToSend;
            this.payloadToSend.size = size || 10;
        },
        setObjectToSend(data) {
            this.objectToSend = data;
        },
        searchForData(data) {
            this.searchData = data;
        }
    }
};
